import {auth} from '../../Auth'
import moment from 'moment';

const filterConverter = {
  clients: (clientsArray) => (clientsArray ? {terms: {[`client.id`]: clientsArray}} : {}),
  intakes: (status) => (status ? {term: {'status.sortable': {value: status}}} : {}),
  timespan: (timespan) => (timespan ? {range: {'created._seconds': {gte: timespan.unix()}}} : {}),
  'inspection.inspector.id': (id) => [['inspection.inspector.id', '==', id]],
  'client.id': (id) => [['client.id', '==', id]],
}

export default function makeQuery(query) {
  const { size = 1000, from = 0, query_strings, barFilters } = query;

  const ff = Object.entries(barFilters).map(([name, value]) => {
    return filterConverter[name](value);
  });

  const orgId = auth.sunkaizenUser.organization.id;

  // Replace previous orgId and user_index filters with a single bool/should
  ff.push({
    bool: {
      should: [
        { match: { 'organization.id': orgId } },
        {
          bool: {
            should: [
              { match: { [`user_index.${orgId}`]: 'client' } },
              { match: { [`user_index.${orgId}`]: 'inspector' } },
              { match: { [`user_index.${orgId}`]: 'installer' } },
            ],
            minimum_should_match: 1,
          }
        }
      ],
      minimum_should_match: 1
    }
  });

  return {
    type: `projects`,
    size,
    from,
    query_strings,
    filters: ff,
    // remove should and minimum_should_match from top-level
  };
}